/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Badge_LinkInputs */

const vi_sidebar_layout_badge_link = /** @type {(inputs: Sidebar_Layout_Badge_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấp 1`)
};

/**

* @param {Sidebar_Layout_Badge_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_badge_link = /** @type {((inputs?: Sidebar_Layout_Badge_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Badge_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_badge_link(inputs)
});